export default __webpack_public_path__ + "static/media/ExclamationMark.a9215468.svg";